import { Component, OnInit } from "@angular/core";
import { Router, Route } from "@angular/router";
import { BnNgIdleService } from "bn-ng-idle";
import Swal from "sweetalert2";
import { SessionTimerService } from "session-expiration-alert";
import { DatePipe } from "@angular/common";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers:[  DatePipe]
})
export class AppComponent {
  title = 'Extranet';
  cantidadSession;
  SessionTime;
  contador = 900;
  startTimer = true;
  constructor(
    private bnIdle: BnNgIdleService,
    private router: Router,
    public sessionTimer: SessionTimerService,
  ) {
    this.bnIdle.startWatching(this.contador).subscribe(res => {
      if (res && sessionStorage.getItem('UserActive')) {
        console.log("session expired");
        Swal.fire({
          title: "Sesión Cerrada",
          text: "Sesión cerrada por inactividad",
          icon: 'warning',
          showConfirmButton:true,
          allowOutsideClick:false,
          heightAuto: false // Resuelve bug visual
        }).then(resp => {
          if (resp.value == true) {
            this.router.navigate(["/login"]);
          }
        });
      }else{
        Swal.fire({
          title: '¿Necesitas ayuda?',
          text: 'Puedes escribirnos via whatsapp',
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          cancelButtonText: 'Si',
          confirmButtonText: 'No',
          heightAuto: false // Resuelve bug visual
        }).then((result) => {
          if (!result.value) {
            window.open("https://wa.me/51957291976", "_blank");
          } else if (
            result.dismiss === Swal.DismissReason.cancel
          ) { }
        });
      }
    });
  }


  ngOnInit() {

  }
}

